"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _GridContainer = _interopRequireDefault(require("vf-comps/build/components/layouts/grid/GridContainer"));

var _GridItem = _interopRequireDefault(require("vf-comps/build/components/layouts/grid/GridItem"));

var _CardContainer = _interopRequireDefault(require("vf-comps/build/components/organisms/cards/cardContainer/CardContainer"));

var _CardContent = _interopRequireDefault(require("vf-comps/build/components/organisms/cards/cardContainer/CardContent"));

var _CardAction = _interopRequireDefault(require("vf-comps/build/components/organisms/cards/cardContainer/CardAction"));

var _SystemIcon = _interopRequireDefault(require("vf-comps/build/components/protons/icons/SystemIcon"));

var _Typography = _interopRequireDefault(require("vf-comps/build/components/protons/typography/Typography"));

var _BoxSizing = _interopRequireDefault(require("vf-comps/build/components/layouts/box/boxSizing/BoxSizing"));

var _BoxStyled = _interopRequireDefault(require("vf-comps/build/components/layouts/box/boxStyled/BoxStyled"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var CustomerCard = function CustomerCard(_ref) {
  var firstVal = _ref.firstVal,
      secondVal = _ref.secondVal,
      thirdKey = _ref.thirdKey,
      thirdVal = _ref.thirdVal,
      fourthKey = _ref.fourthKey,
      fourthVal = _ref.fourthVal,
      handleCardClick = _ref.handleCardClick;
  var theme = (0, _core.useTheme)();
  var isSmall = (0, _core.useMediaQuery)(theme.breakpoints.down('xs'));
  var BoxSize = isSmall ? _BoxSizing.default : _react.Fragment;
  /**
   * render rows
   * @param {*} key
   * @param {*} value
   */

  var renderLeftRowsCard = function renderLeftRowsCard(key, value, testId) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "test-customer-card",
      "data-testid": "customer-card-".concat(testId, "-container")
    }, /*#__PURE__*/_react.default.createElement(_GridItem.default, null, /*#__PURE__*/_react.default.createElement(_GridContainer.default, null, /*#__PURE__*/_react.default.createElement(_BoxSizing.default, null, /*#__PURE__*/_react.default.createElement(_GridItem.default, null, /*#__PURE__*/_react.default.createElement(_BoxStyled.default, {
      className: {
        marginRight: '5px',
        display: 'inline-block',
        whiteSpace: 'pre-line'
      }
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      text: "".concat(key),
      "data-testid": "".concat(testId, "-text"),
      color: "MidGrey",
      variant: "footerNote",
      component: "span"
    })), /*#__PURE__*/_react.default.createElement(_BoxStyled.default, {
      className: {
        verticalAlign: 'top',
        display: 'inline-block',
        maxWidth: 'auto',
        whiteSpace: 'pre-line'
      }
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      text: "".concat(value),
      "data-testid": "".concat(testId, "-value"),
      color: "VfGrey",
      variant: "footerNote",
      component: "span"
    })))))));
  };

  var IconWrapper = isSmall ? _BoxStyled.default : _react.Fragment;
  return /*#__PURE__*/_react.default.createElement(_BoxSizing.default, {
    mb: "small"
  }, /*#__PURE__*/_react.default.createElement(_GridItem.default, {
    xs: true
  }, /*#__PURE__*/_react.default.createElement(_CardContainer.default, {
    color: null
  }, /*#__PURE__*/_react.default.createElement(_CardAction.default, {
    "data-testid": "click",
    action: handleCardClick
  }, /*#__PURE__*/_react.default.createElement(_CardContent.default, null, /*#__PURE__*/_react.default.createElement(_GridContainer.default, {
    direction: isSmall ? 'column' : 'row',
    alignItems: isSmall ? '' : 'baseline'
  }, /*#__PURE__*/_react.default.createElement(_GridItem.default, {
    xs: 12,
    sm: 6,
    md: 7
  }, /*#__PURE__*/_react.default.createElement(BoxSize, null, /*#__PURE__*/_react.default.createElement(_GridContainer.default, {
    isDense: true,
    disableGutters: true,
    direction: "column"
  }, /*#__PURE__*/_react.default.createElement(_GridItem.default, {
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_GridItem.default, null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    bold: true,
    text: firstVal,
    color: "VfGrey",
    variant: "footerNote",
    "data-testid": "user_name"
  })), /*#__PURE__*/_react.default.createElement(_BoxSizing.default, {
    mt: "mini"
  }), /*#__PURE__*/_react.default.createElement(_GridItem.default, null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    text: secondVal,
    color: "VfGrey",
    variant: "footerNote",
    "data-testid": "segment-text"
  })))))), /*#__PURE__*/_react.default.createElement(BoxSize, isSmall ? {
    pt: 'mini',
    pl: 'small',
    pb: 'small'
  } : {}, /*#__PURE__*/_react.default.createElement(_GridItem.default, {
    xs: 12,
    sm: 6,
    md: 5
  }, /*#__PURE__*/_react.default.createElement(_GridContainer.default, {
    direction: "row",
    alignItems: isSmall ? '' : 'center'
  }, /*#__PURE__*/_react.default.createElement(_GridItem.default, {
    xs: 12,
    sm: 10
  }, /*#__PURE__*/_react.default.createElement(_GridContainer.default, {
    direction: "column",
    disableGutters: true
  }, thirdVal && renderLeftRowsCard(thirdKey, thirdVal, 'IDNumber'), /*#__PURE__*/_react.default.createElement(_BoxSizing.default, {
    mt: "large"
  }), fourthVal && renderLeftRowsCard(fourthKey, fourthVal, 'TaxNumber'))), /*#__PURE__*/_react.default.createElement(IconWrapper, {
    className: {
      position: 'absolute',
      top: '28px',
      right: '12px'
    }
  }, /*#__PURE__*/_react.default.createElement(_GridItem.default, {
    xs: 1,
    sm: 1
  }, /*#__PURE__*/_react.default.createElement(_SystemIcon.default, {
    color: "red",
    icon: "ic_chevron__right",
    size: "Large"
  }))))))))))));
};

var _default = CustomerCard;
exports.default = _default;